import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { Observable } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { UnsubscribeComponent } from '../../../../shared-components/components/unsubscribe/unsubscribe.abstract';
import { AuthResponse } from '../../../models/auth-response.model';
import { SnackBarService } from '../../../../shared-services/services/snack-bar.service';
import { UntypedFormGroup, UntypedFormBuilder, Validators } from '@angular/forms';
import { ValidateEmailLinkRequest } from '../../../models/validate-email-link-request.model';
import { ValidateEmailLinkResponse } from '../../../models/validate-email-link-response.model';
import { RegistrationService } from '../../../../registration-3/services/registration.service';

@Component({
    selector: 'app-email-link-validation',
    templateUrl: './email-link-validation.component.html',
    styleUrls: ['./email-link-validation.component.scss'],
    standalone: false
})
export class EmailLinkValidationComponent extends UnsubscribeComponent implements OnInit {

    public sendVerificationLink$: any;
    public authResponse$: Observable<AuthResponse>;
    public validateEmail$: Observable<ValidateEmailLinkResponse>;
    public validateEmailLinkRequest: ValidateEmailLinkRequest;
    public params$: any;
    public loaderShowing = true;
    public emailValidationCode: string;
    public redirectUrl: string;
    public token: string;
    public emailValidationFormGroup: UntypedFormGroup;
    public serverError = true;
    public companyPrimaryLogo: string;
    public key: string;

    constructor(
        private route: ActivatedRoute,
        private router: Router,
        private registrationService: RegistrationService,
        private snackbarService: SnackBarService,
        private formBuilder: UntypedFormBuilder) {
        super();
    }
    ngOnInit(): void {
        this.emailValidationFormGroup = this.formBuilder.group({
            emailControl: ['', Validators.pattern('.*[0-9a-zA-Z]+.*@.*[0-9a-zA-Z]+.*\\.[a-zA-Z]+')],
            verificationType: ['Email', Validators.required]
        });
        this.getParams();
    }

    private getParams() {
        this.route.queryParams.subscribe(params => {
            this.redirectUrl = params['redirectUrl'];
            if (this.redirectUrl != null && this.redirectUrl.includes('?')) {
                const splittedUrl = this.redirectUrl.split('?');
                const urlparams = new URLSearchParams('?' + splittedUrl[1]);
                this.validateEmailLinkRequest = new ValidateEmailLinkRequest({
                    code: urlparams.get('key'),
                    token: urlparams.get('token')
                });
            } else {
                // we have to remove else part code once we will get deeplink url on click of verify link
                this.validateEmailLinkRequest = new ValidateEmailLinkRequest({
                    code: params['key'],
                    token: params['token']
                });
            }
            this.validateEmailCode();
        });
    }

    public validateEmailCode() {
        this.validateEmail$ = this.registrationService.verifyEmailCode(this.validateEmailLinkRequest);

        this.validateEmail$
            .pipe(takeUntil(this.unsubscriber))
            .subscribe((response: ValidateEmailLinkResponse) => {
                this.companyPrimaryLogo = response.CompanyPrimaryLogo;
                this.loaderShowing = false;
                this.redirectToLoginWithRedirectUrl(true);
            }, (err) => {
                if (err) {
                    this.companyPrimaryLogo = err.error.CompanyPrimaryLogo;
                    this.loaderShowing = false;
                }
                this.snackbarService.openWarnSnackbar('Email Already Validated.');
                this.redirectToLoginWithRedirectUrl(false);
            });
    }

    public submit() {

        this.serverError = false;

        this.sendVerificationLink$ = this.registrationService.sendEmailCode();

        this.sendVerificationLink$
            .pipe(takeUntil(this.unsubscriber))
            .subscribe(() => {
                this.snackbarService
                    .openSuccessSnackbar('A new verification email has been sent to your email address that is on file in  our system.');
            });
    }

    public errorCommunicating(): boolean {
        return this.emailValidationFormGroup
            .get('emailControl')
            .hasError('errorCommunicating');
    }

    public emailRequired(): boolean {
        return this.emailValidationFormGroup
            .get('emailControl')
            .hasError('required');
    }

    public invalidEmail(): boolean {
        return this.emailValidationFormGroup
            .get('emailControl')
            .hasError('invalidEmail');
    }

    public emailChanged(): void {
        this.serverError = false;
    }

    public redirectToLogin(): void {
        setTimeout(() => {
            this.router.navigate(['/login']);
        }, 2000);
    }

    private redirectToLoginWithRedirectUrl(isEmailVerified: boolean): void {
        setTimeout(() => {
            this.router.navigate(['/login'], { queryParams: { isValidated: isEmailVerified, redirectUrl: this.redirectUrl } });
        }, 1000);
    }
}
